import Entity from '../entity'

export default class CuentaEmisora extends Entity<number>{
    numero: string;
    nombre: string;
    msg_transferencia: string;
    entidadEmisora: string;
    direccionEmisora: string;
    cifEmisor:string
}